import { render, staticRenderFns } from "./PageGridItem.vue?vue&type=template&id=c78bc468&"
import script from "./PageGridItem.vue?vue&type=script&lang=js&"
export * from "./PageGridItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports